
    <div role="alert" *ngIf="e && !e.disabled && (e.invalid | async) && ((e.ngForm && e.ngForm['validateOnSubmit'] && e.ngForm.submitted) || (!(e.ngForm && e.ngForm['validateOnSubmit']) && (e.dirty || e.touched)))">
      <label [ngClass]="'label label-danger'" *ngFor="let message of (e.failures | async)">
        {{ message }}
      </label>
    </div>
  


// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵg.html